import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';

class TrailAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onNewCardClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onSeeAllClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  isCanAddNewItem(): boolean {
    return this.state.canAddNewItem;
  }

  setCanAddNewItem(canAddNewItem: boolean): void {
    this.setState({ canAddNewItem });
  }

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  isDateVisible(): boolean {
    return this.state.dateVisible;
  }

  setDateVisible(dateVisible: boolean): void {
    this.setState({ dateVisible });
  }

  getEmptyResultSubtitle(): string {
    return this.state.emptyResultSubtitle;
  }

  setEmptyResultSubtitle(emptyResultSubtitle: string): void {
    this.setState({ emptyResultSubtitle });
  }

  getEmptyResultTitle(): string {
    return this.state.emptyResultTitle;
  }

  setEmptyResultTitle(emptyResultTitle: string): void {
    this.setState({ emptyResultTitle });
  }

  getItemsPerPage(): number {
    return this.state.itemsPerPage;
  }

  setItemsPerPage(itemsPerPage: number): void {
    this.setState({ itemsPerPage });
  }

  isLoading(): boolean {
    return this.state.loading;
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }

  getNewItemText(): string {
    return this.state.newItemText;
  }

  setNewItemText(newItemText: string): void {
    this.setState({ newItemText });
  }

  getSeeAll(): string {
    return this.state.seeAll;
  }

  setSetAll(seeAll: string): void {
    this.setState({ seeAll });
  }

  isShowSeeAll(): boolean {
    return this.state.showSeeAll;
  }

  setShowSeeAll(showSeeAll: boolean): void {
    this.setState({ showSeeAll });
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

}

export default TrailAPI;
